import isString from 'lodash.isstring';

export const camelToSnakeCase = (str) => {
    if (!isString(str)) {
        throw new Error(`camelToSnakeCase requires string as an argument. Got: ${typeof str}`);
    }
    return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

export const snakeToCamelCase = (str) => {
    if (!isString(str)) {
        throw new Error(`snakeToCamelCase requires string as an argument. Got: ${typeof str}`);
    }
    return str.replace(/([-_][a-z])/g, (group) =>
        group.toUpperCase().replace('-', '').replace('_', '')
    );
};

export const upperFirstLetter = (str) => {
    if (!isString(str)) {
        throw new Error(`upperFirstLetter requires string as an argument. Got: ${typeof str}`);
    }
    if (str?.length === 0) return '';
    if (str?.length === 1) return str.charAt(0).toUpperCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const lowerFirstLetter = (str) => {
    if (!isString(str)) {
        throw new Error(`lowerFirstLetter requires string as an argument. Got: ${typeof str}`);
    }
    if (str?.length === 0) return '';
    if (str?.length === 1) return str.charAt(0).toUpperCase();
    return str.charAt(0).toLowerCase() + str.slice(1);
};

export default {
    camelToSnakeCase,
    snakeToCamelCase,
    upperFirstLetter,
    lowerFirstLetter
};
